import '../shared/sv-hover-intent.js';

import Mustache from 'mustache';
import headerAnalytics from 'header.analytics';
import headerData from 'header.data';
import headerMask from 'header.mask';
import utils from '../shared/utils';

const homeDecorFurnitureFlyout = {};
let homeDecorFurnitureData = null;

homeDecorFurnitureFlyout.templates = {};

homeDecorFurnitureFlyout.templates.subnav =
  '<ul class="homeDecorFurnitureFlyout__list">' +
  '    {{#aisles}} ' +
  '        <li>' +
  '            <a class="homeDecorFurnitureFlyout__link" ' +
  '               href="{{link}}" ' +
  '               id="{{id}}">' +
  '                {{name}} ' +
  '            </a>' +
  '        </li>' +
  '    {{/aisles}} ' +
  '</ul>';

homeDecorFurnitureFlyout.templates.staticSubnav =
  '<ul class="homeDecorFurnitureFlyout__list">' +
  '    <li>' +
  '        <a class="homeDecorFurnitureFlyout__link" ' +
  '           href="//www.homedepot.com/b/Home-Decor/N-5yc1vZas6p" ' +
  '           id="home-decor">Home Decor</a>' +
  '    </li>' +
  '    <li>' +
  '        <a class="homeDecorFurnitureFlyout__link" ' +
  '           href="//www.homedepot.com/b/Furniture/N-5yc1vZc7pc" ' +
  '           id="furniture">Furniture</a>' +
  '    </li>' +
  '    <li>' +
  '        <a class="homeDecorFurnitureFlyout__link" ' +
  '           href="//www.homedepot.com/b/Kitchen-Kitchenware/N-5yc1vZaqzo" ' +
  '           id="kitchen-and-dining">Kitchen &amp; Dining</a>' +
  '    </li>' +
  '    <li>' +
  '        <a class="homeDecorFurnitureFlyout__link" ' +
  '           href="//www.homedepot.com/b/Home-Decor-Bedding-Bath/N-5yc1vZci04" ' +
  '           id="bedding-and-bath">Bedding &amp; Bath</a>' +
  '    </li>' +
  '    <li>' +
  '        <a class="homeDecorFurnitureFlyout__link" ' +
  '           href="//www.homedepot.com/b/Lighting/N-5yc1vZbvn5" ' +
  '           id="lighting">Lighting</a>' +
  '    </li>' +
  '    <li>' +
  '        <a class="homeDecorFurnitureFlyout__link" ' +
  '           href="//www.homedepot.com/b/Window-Treatments/N-5yc1vZar4w" ' +
  '           id="window-treatments">Window Treatments</a>' +
  '    </li>' +
  '    <li>' +
  '        <a class="homeDecorFurnitureFlyout__link" ' +
  '           href="//www.homedepot.com/room" ' +
  '           id="shop-by-room">Shop by Room</a>' +
  '    </li>' +
  '    <li>' +
  '        <a class="homeDecorFurnitureFlyout__link" ' +
  '           href="//www.homedepot.com/c/Savings_Center" ' +
  '           id="savings">Savings</a>' +
  '    </li>' +
  '</ul>';

homeDecorFurnitureFlyout.templates.columnarMenu =
  '{{#columns}} ' +
  '    <div class="homeDecorFurnitureFlyout__column {{#hero}}homeDecorFurnitureFlyout__column--hero{{/hero}} {{#showSeparator}}homeDecorFurnitureFlyout__column--separator{{/showSeparator}}">' +
  '        {{#hero}}' +
  '         <div class="homeDecorFurnitureFlyout__hero">' +
  '           <a class="homeDecorFurnitureFlyout__hero-banner homeDecorFurnitureFlyout__endpoint" href="{{hero.shopAllLink}}" style="color: {{hero.fontColor}}; background-color: {{hero.bannerBackgroundColor}}">' +
  '             <span class="homeDecorFurnitureFlyout__hero-banner-name">{{hero.name}}</span>' +
  '             <span class="homeDecorFurnitureFlyout__hero-banner-shop">{{hero.shopAll}}</span>' +
  '           </a>' +
  '           <a class="homeDecorFurnitureFlyout__hero-image homeDecorFurnitureFlyout__endpoint" href="{{hero.bannerLink}}" style="background-image:url({{hero.bannerImageURL}});">' +
  '           </a>' +
  '         </div>' +
  '        {{/hero}}' +
  '        {{#bays}} ' +
  '            <div class="homeDecorFurnitureFlyout__bay {{#hero}}homeDecorFurnitureFlyout__bay--hero{{/hero}} {{#inlineImage}}homeDecorFurnitureFlyout__bay--inline{{/inlineImage}}">' +
  '                {{#bayLink}} ' +
  '                    <div class="homeDecorFurnitureFlyout__bayName">' +
  '                        <a class="homeDecorFurnitureFlyout__endpoint" href="{{bayLink}}">' +
  '                            {{bayName}} ' +
  '                        </a>' +
  '                    </div>' +
  '                {{/bayLink}} ' +
  '                {{^bayLink}} ' +
  '                    <div class="homeDecorFurnitureFlyout__bayName {{#hero}}homeDecorFurnitureFlyout__bayName--hero{{/hero}}">' +
  '                        {{bayName}} ' +
  '                    </div>' +
  '                {{/bayLink}} ' +
  '                <div class="homeDecorFurnitureFlyout__columns {{^featuredBrands}}homeDecorFurnitureFlyout__columns--hidden{{/featuredBrands}}">' +
  '                {{#featuredBrands}}' +
  '                  <div class="homeDecorFurnitureFlyout__shelf-column">' +
  '                    {{#columns}}' +
  '                      <div class="{{^promotional}}homeDecorFurnitureFlyout__shelf-brands{{/promotional}}{{#promotional}}homeDecorFurnitureFlyout__shelf-promos{{/promotional}}">' +
  '                      {{#imageURL}}' +
  '                        <a href="{{shelfLink}}" class="homeDecorFurnitureFlyout__endpoint" style="background-image:url({{imageURL}})" title="{{shelfName}}"></a>' +
  '                      {{/imageURL}}' +
  '                      {{^imageURL}}' +
  '                        <a class="homeDecorFurnitureFlyout__endpoint" href="{{shelfLink}}">' +
  '                          {{shelfName}} ' +
  '                        </a>' +
  '                      {{/imageURL}}' +
  '                      </div>' +
  '                    {{/columns}}' +
  '                  </div>' +
  '                {{/featuredBrands}}' +
  '                </div>' +
  '                {{^featuredBrands}}' +
  '                  {{#shelves}} ' +
  '                      <div class="homeDecorFurnitureFlyout__shelf">' +
  '                          {{#shelfLink}} ' +
  '                              <a class="homeDecorFurnitureFlyout__endpoint" href="{{shelfLink}}">' +
  '                                {{shelfName}} ' +
  '                              </a>' +
  '                          {{/shelfLink}} ' +
  '                          {{^shelfLink}} ' +
  '                              {{shelfName}} ' +
  '                          {{/shelfLink}} ' +
  '                      </div>' +
  '                  {{/shelves}} ' +
  '                {{/featuredBrands}}' +
  '                {{#imageURL}} ' +
  '                    <div class="homeDecorFurnitureFlyout__bayImage">' +
  '                        <a class="homeDecorFurnitureFlyout__endpoint homeDecorFurnitureFlyout__endpoint--image" ' +
  '                           style="background-image:url({{imageURL}})" ' +
  '                           href="{{bayLink}}" ' +
  '                           id="catalog image"></a>' +
  '                    </div>' +
  '                {{/imageURL}} ' +
  '            </div>' +
  '        {{/bays}} ' +
  '    </div>' +
  '{{/columns}}';

homeDecorFurnitureFlyout.templates.collageMenu =
  '<div class="homeDecorFurnitureFlyout__shopByRoom">' +
  '    {{#bays}} ' +
  '        <div class="homeDecorFurnitureFlyout__room">' +
  '            <a class="homeDecorFurnitureFlyout__endpoint homeDecorFurnitureFlyout__roomImage homeDecorFurnitureFlyout__endpoint--image" ' +
  '               style="background-image:url({{imageURL}})" ' +
  '               href="{{link}}" ' +
  '               id="{{roomName}}"></a>' +
  '            <a class="homeDecorFurnitureFlyout__endpoint" href="{{link}}">' +
  '                {{roomName}} ' +
  '            </a>' +
  '        </div>' +
  '    {{/bays}} ' +
  '</div>';

homeDecorFurnitureFlyout.analyticsSelectedAisle = null;
homeDecorFurnitureFlyout.breadcrumbAisleElement = null;

homeDecorFurnitureFlyout.clearUrl = function _clearUrl(urlString) {
  // Need to ensure this value isn't just a placeholder
  // if it is, we need to remove the string so Mustache can tell.
  return urlString === '#' ? '' : urlString;
};

homeDecorFurnitureFlyout.determineAisle = function _determineAisle() {
  function highlightBreadcrumbAisleElement(breadcrumbs) {
    homeDecorFurnitureFlyout.breadcrumbAisleElement = null;

    breadcrumbs.forEach((breadcrumb) => {
      const breadcrumbNValue = homeDecorFurnitureFlyout.generateBreadcrumbNValue(breadcrumb);

      if (homeDecorFurnitureData && homeDecorFurnitureData.aisles) {
        const filteredAisles =
          homeDecorFurnitureData.aisles
            .filter(aisle => aisle.link && aisle.link.indexOf(breadcrumbNValue) !== -1);
        if (filteredAisles.length === 1) {
          homeDecorFurnitureFlyout.breadcrumbAisleElement = document.querySelector(`.homeDecorFurnitureFlyout__link#${filteredAisles[0].id}`);
        }
      }
    });

    if (homeDecorFurnitureFlyout.breadcrumbAisleElement === null) {
      breadcrumbs.forEach((breadcrumb) => {
        const breadcrumbNValue = homeDecorFurnitureFlyout.generateBreadcrumbNValue(breadcrumb);

        if (homeDecorFurnitureData && homeDecorFurnitureData.aisles) {
          homeDecorFurnitureData.aisles.forEach((aisle) => {
            if (aisle && aisle.bayNValues) {
              const filteredBays =
                aisle.bayNValues.filter(bayNValue => bayNValue === breadcrumbNValue);
              if (filteredBays.length === 1) {
                homeDecorFurnitureFlyout.breadcrumbAisleElement = document.querySelector(`.homeDecorFurnitureFlyout__link#${aisle.id}`);
              }
            }
          });
        }
      });
    }

    homeDecorFurnitureFlyout.highlightAisle('.homeDecorFurnitureFlyout__subnav', homeDecorFurnitureFlyout.breadcrumbAisleElement);
  }

  if (headerData.checkEventBus()) {
    const EVENT_BUS = window.THD_EVENT_BUS || window.LIFE_CYCLE_EVENT_BUS;

    EVENT_BUS.lifeCycle.on('breadcrumbs.ready', (data) => {
      if (!data || !data.output) return;
      const breadcrumbs = data.output.crumbs;

      if (breadcrumbs) {
        highlightBreadcrumbAisleElement(breadcrumbs);
      }
    });

    EVENT_BUS.on('@@HDHOME/PAGE_LOAD', (data) => {
      if (!data || !data.output) return;
      const breadcrumbs = data.output.breadCrumbs ?
        data.output.breadCrumbs :
        data.output.response.breadCrumbs;

      if (breadcrumbs) {
        highlightBreadcrumbAisleElement(breadcrumbs);
      }
    });
  }
};

homeDecorFurnitureFlyout.generateBreadcrumbNValue = function _generateBreadcrumbNValue(breadcrumb) {
  let breadcrumbNValue = null;
  if (breadcrumb && breadcrumb.url && typeof breadcrumb?.url === 'string') {
    const splitURL = (breadcrumb.url || '').split('/');
    breadcrumbNValue = splitURL.filter(part => part.indexOf('N-') !== -1)[0];
  }
  return breadcrumbNValue;
};

homeDecorFurnitureFlyout.getFlyoutData = function getFlyoutData() {
  const flyoutDataRetrieved = utils.deferred();
  flyoutDataRetrieved.promise().then(homeDecorFurnitureFlyout.renderSubnav);
  
  if (!homeDecorFurnitureData) {
    // const jsonPath = '../../test/test_homedecor_heroes.json';
    // const responseDataPromise = $.getJSON(jsonPath);
    
    const jsonPath = '/hdus/en_US/DTCCOMNEW/fetch/homeDecorFurnitureFlyout.json';
    const responseDataPromise = headerData.getEtchJSON(jsonPath);

    responseDataPromise
      .then((jsonResponse) => {
        homeDecorFurnitureFlyout.getFlyoutDataSuccess(jsonResponse);
        flyoutDataRetrieved.resolve();
      }, homeDecorFurnitureFlyout.getFlyoutDataError());
  } else {
    flyoutDataRetrieved.resolve();
  }
};

homeDecorFurnitureFlyout.getFlyoutDataError = function _getFlyoutDataError() {
  document.querySelectorAll('.homeDecorFurnitureFlyout__subnav')?.forEach(subnav => {
    subnav.innerHTML = homeDecorFurnitureFlyout.templates.staticSubnav;
  })
};

function getBayNValues(columns) {
  const nValues = columns.map((column) => {
    const { bays = [] } = column;
    return bays.map((bay) => {
      const { link = '' } = bay;
      const nIndex = link.indexOf('N-');
      if (nIndex < 0) {
        return null;
      }
      return link.slice(nIndex);
    }).filter(b => !!b);
  });
  return [].concat.apply([], nValues);
}

function processShelves(shelves) {
  return shelves.map((shelf) => {
    const { name, link } = shelf;
    return Object.assign(shelf, { shelfName: name, shelfLink: link });
  });
}

/** *
 * Aisles represent each "Tab" of the subnav bar
 * @param aisle
 * @returns {{name: string, id: string, bayNValues: [], columns: [], link: string}}
 */
function processAisle(aisle) {
  // Shop-by-room has bays at the aisle level :|
  const {
    bays = [], columns = [], id, link = '', name
  } = aisle;
  const bayNValues = getBayNValues(columns);
  const processedAisle = { bayNValues, id, name };
  processedAisle.link = link.replace('https:', '');

  if (columns.length) {
    processedAisle.columns = columns.map(column => processColumn(aisle, column));
  } else if (bays.length && name === 'Shop by Room') {
    processedAisle.bays = bays.map(room => Object.assign(room, { roomName: room.name }));
  }
  return processedAisle;
}

homeDecorFurnitureFlyout.processBay = function _processBay(bay, hero) {
  const { link, name, shelves = [] } = bay;
  const processedShelves = processShelves(shelves);
  const featuredBrands = homeDecorFurnitureFlyout.processBrands(bay, hero);
  const processedBay = Object.assign(bay, { bayName: name });

  // TODO: just include these
  if (link) {
    processedBay.bayLink = link;
  }

  if (processedShelves.length) {
    processedBay.shelves = processedShelves;
  }

  if (featuredBrands.length) {
    processedBay.featuredBrands = featuredBrands;
  }
  return processedBay;
};

function chunkArray(toChunkArray, columnCount) {
  if (columnCount < 2) {
    return [toChunkArray];
  }

  const arrayLength = toChunkArray.length;
  const chunks = [];
  let i = 0;
  let size;

  if (arrayLength % columnCount === 0) {
    size = Math.floor(arrayLength / columnCount);
    while (i < arrayLength) {
      chunks.push(toChunkArray.slice(i, i += size));
    }
  } else {
    while (i < arrayLength) {
      size = Math.ceil((arrayLength - i) / columnCount--);
      chunks.push(toChunkArray.slice(i, i += size));
    }
  }
  return chunks;
}

/**
 * Brands will be displayed in 3 columns when a hero is present.
 * Promotional blocks take up the entire column however,
 * they can co-exist with the other column types so it's easiest
 * to structure the data in column format and render that.
 * @param bay
 * @param hero
 * @returns {Array}
 */
homeDecorFurnitureFlyout.processBrands = function _processBrands(bay, hero) {
  const { name, shelves = [] } = bay;
  const promotionals = shelves.filter(shelf => shelf.promotional);
  if (!(hero && /Brands/i.test(name))) {
    return [];
  }

  const brands = promotionals.map(promo => ({
    columns: [promo],
    promotional: true
  }));
  const nonPromos = shelves.filter(shelf => !shelf.promotional);
  const availableColumns = 3 - promotionals.length;
  const chunks = chunkArray(nonPromos, availableColumns);
  chunks.forEach((chunk) => {
    brands.push({ columns: chunk, promotional: false });
  });

  return brands.slice(0, Math.min(brands.length, 3));
};

function processColumn(aisle, column) {
  const { bays = [], hero } = column;
  const processedBays = bays.map(bay => homeDecorFurnitureFlyout.processBay(bay, hero));
  if (hero) {
    hero.bannerBackgroundColor = hero.bannerBackgroundColor || '#f2f2f1';
    hero.fontColor = hero.fontColor || '#333';
    hero.shopAll = hero.shopAll || 'Shop All';
  }
  const processedColumn = Object.assign({}, column);
  if (processedBays.length) {
    processedColumn.bays = processedBays;
  }
  return processedColumn;
}

homeDecorFurnitureFlyout.addSeparators = function _addSeparators(aisle) {
  const updatedAisle = Object.assign({}, aisle);
  const { columns = [] } = updatedAisle;
  const separatedColumns = columns.map((column) => {
    const { bays = [], hero } = column;
    const hasImage = bays.filter(bay => bay.imageURL).length;
    const separatedColumn = Object.assign({}, column);
    separatedColumn.showSeparator = !(bays.length === 0 || hero || hasImage);
    return separatedColumn;
  });
  if (separatedColumns.length) {
    updatedAisle.columns = separatedColumns;
  }
  return updatedAisle;
};

homeDecorFurnitureFlyout.getFlyoutDataSuccess = function _getFlyoutDataSuccess(jsonResponse) {
  homeDecorFurnitureData = jsonResponse;
  const { aisles } = homeDecorFurnitureData;

  // Process all elements so Mustache can understand
  if (aisles) {
    homeDecorFurnitureData.aisles = aisles.map(aisle => processAisle(aisle));
  }
  return homeDecorFurnitureData;
};

homeDecorFurnitureFlyout.highlightAisle = function _highlightAisle(menu, item) {
  if (menu) {
    document.querySelectorAll(menu)?.forEach(menu => {
      menu.querySelectorAll('.homeDecorFurnitureFlyout__link--active')?.forEach((link) => {
      link.classList?.remove('homeDecorFurnitureFlyout__link--active');
      })
    });
  }
  if (item) {
    item?.classList?.add('homeDecorFurnitureFlyout__link--active');
  }
};

homeDecorFurnitureFlyout.interactWithAisle = function _interactWithAisle(event) {
  const isEventTypeHoverIntent = event?.target ? false : true;

  if (event.type === 'touchend') {
    homeDecorFurnitureFlyout.stopTouchHandling(event);
    homeDecorFurnitureFlyout.highlightAisle('.homeDecorFurnitureFlyout__subnav', event?.target);
    homeDecorFurnitureFlyout.renderMenu(event?.target?.textContent?.trim());
  } else if (isEventTypeHoverIntent){
    homeDecorFurnitureFlyout.highlightAisle('.homeDecorFurnitureFlyout__subnav', event);
    homeDecorFurnitureFlyout.renderMenu(event?.textContent?.trim());
  } else {
    homeDecorFurnitureFlyout.analyticsSelectedAisle = event?.target?.textContent?.toLowerCase().replace('&', 'and').trim();
    homeDecorFurnitureFlyout.logInteractionForL2();
  }
};

homeDecorFurnitureFlyout.logEventPath = function _logEventPath(type, pathArray) {
  // Get header at the beginning, then join them all
  const level1 = 'home decor and furniture';
  return headerAnalytics.logEvent(type, ['header', level1].concat(pathArray).join('>'));
};

homeDecorFurnitureFlyout.logInteractionForL2 = function _logInteractionForL2() {
  // L2 is an aisle in the subnav
  const level2 = homeDecorFurnitureFlyout.analyticsSelectedAisle;
  return homeDecorFurnitureFlyout.logEventPath('header click', [level2]);
};

homeDecorFurnitureFlyout.logInteractionForL3 = function _logInteractionForL3(event) {
  // L3 is either a bay, shelf, or image in the menu
  const level2 = homeDecorFurnitureFlyout.analyticsSelectedAisle;

  // if the user clicked on a bay or a shelf, then use the corresponding text
  // else the user clicked on an image which is either a room or a catalog
  // for an image, use the associated id
  let level3 = null;
  let featuredBrand = null;

  if (this.textContent) {
    if (this.classList?.contains('homeDecorFurnitureFlyout__hero-image')) {
      level3 = `${level2} image`;
    } else {
      level3 = this.textContent.toLowerCase().replace('&', 'and')
        .trim();
    }
  } else if (this.context && this.context.id) {
    level3 = this.context.id.toLowerCase().replace('&', 'and').trim();
  } else if (this.getAttribute('title')) {
    level3 = 'featured brands';
    featuredBrand = this.getAttribute('title').toLowerCase().replace('&', 'and').trim();
  }

  if (level3 && level3.includes('shop all')) {
    level3 = level2.trim().concat(' shop all');
  }

  if (featuredBrand) {
    homeDecorFurnitureFlyout.logEventPath('header click', [level2, level3, featuredBrand]);
  } else {
    homeDecorFurnitureFlyout.logEventPath('header click', [level2, level3]);
  }

  window.location.href = event.currentTarget.href;
};

homeDecorFurnitureFlyout.renderMenu = function _renderMenu(aisleName) {
  let reRenderMenu = false;
  if (homeDecorFurnitureFlyout.analyticsSelectedAisle && homeDecorFurnitureFlyout.analyticsSelectedAisle === 'shop by room') {
    reRenderMenu = true;
  }

  if (homeDecorFurnitureData) {
    homeDecorFurnitureFlyout.analyticsSelectedAisle = aisleName.toLowerCase().replace('&', 'and').trim();

    const menuSelector = document.querySelector('.homeDecorFurnitureFlyout__menu');

    let htmlContent;

    let aisle = {};
    homeDecorFurnitureData.aisles.forEach((element) => {
      if (element.name === aisleName) {
        aisle = element;
      }
    });

    if (aisleName === 'Shop by Room') {
      htmlContent = Mustache.render(homeDecorFurnitureFlyout.templates.collageMenu, aisle);
    } else {
      homeDecorFurnitureFlyout.addSeparators(aisle);
      htmlContent = Mustache.render(homeDecorFurnitureFlyout.templates.columnarMenu, aisle);
    }

    document.querySelector('.homeDecorFurnitureSubnav__subnav-wrapper')?.
      classList?.add('homeDecorFurnitureSubnav--open');

    headerMask.show();

    utils.setInnerHtml('.homeDecorFurnitureFlyout__menu', htmlContent)

    menuSelector?.classList?.add('homeDecorFurnitureFlyout__menu--open');
    document.querySelector('.homeDecorFurnitureFlyout__menu-wrapper')?.
      classList?.add('homeDecorFurnitureFlyout--open');
    
    // adding hoverintents for subnav links
    const homeDecorFlyoutLinks = Array.from(document.querySelectorAll('.homeDecorFurnitureFlyout__subnav .homeDecorFurnitureFlyout__link'));
    new SV.HoverIntent(homeDecorFlyoutLinks,
      {
        onEnter: (targetItem) => {
          homeDecorFurnitureFlyout.interactWithAisle(targetItem);
        },
        onExit: () => {}
      })

    homeDecorFurnitureFlyout.registerHoverIntent('.homeDecorFurnitureFlyout__link');

    if (reRenderMenu && aisle && aisle.name) {
      if (aisle.name.toLowerCase().trim() === 'shop by room') {
        homeDecorFurnitureFlyout.reRenderPostShopByRoomMenu(homeDecorFurnitureFlyout.templates.collageMenu, aisle);
      } else {
        homeDecorFurnitureFlyout.reRenderPostShopByRoomMenu(homeDecorFurnitureFlyout.templates.columnarMenu, aisle);
      }
    }
  }
};

homeDecorFurnitureFlyout.renderSubnav = function _renderSubnav() {
  if (homeDecorFurnitureData) {
    document.querySelectorAll('.homeDecorFurnitureFlyout__subnav')?.forEach(subnav => {
      subnav.innerHTML = Mustache.render(homeDecorFurnitureFlyout.templates.subnav, homeDecorFurnitureData);
    })

    const homeDecorFlyoutLinks = Array.from(document.querySelectorAll('.homeDecorFurnitureFlyout__subnav .homeDecorFurnitureFlyout__link'));
    new SV.HoverIntent(homeDecorFlyoutLinks,
      {
        onEnter: (targetItem) => {
          homeDecorFurnitureFlyout.interactWithAisle(targetItem);
        },
        onExit: () => {}
      });

    homeDecorFurnitureFlyout.registerHoverIntent('.homeDecorFurnitureFlyout__link');

    homeDecorFurnitureFlyout.determineAisle();
  }
};

// eslint-disable-next-line max-len
homeDecorFurnitureFlyout.reRenderPostShopByRoomMenu = function _reRenderPostShopByRoomMenu(template, aisle) {
  const menuHTMLContent = Mustache.render(template, aisle);
  utils.setInnerHtml('.homeDecorFurnitureFlyout__menu', menuHTMLContent)
};

homeDecorFurnitureFlyout.setMenuState = function _setMenuState(state) {
  document.querySelector('.homeDecorFurnitureFlyout')?.
    classList?.toggle('homeDecorFurnitureFlyout', (state === 'bay'));
};

homeDecorFurnitureFlyout.stopTouchHandling = function _stopTouchHandling(event) {
  // If this is a touch interaction
  if (event?.type === 'touchend') {
    // Prevent the normal behavior
    event.preventDefault();
    event.stopPropagation();
  }
};

homeDecorFurnitureFlyout.registerHoverIntent = function _registerHoverIntent(selector) {
  new SV.HoverIntent(document.querySelectorAll(selector),
    {
      onEnter: (targetElement) => {
        homeDecorFurnitureFlyout.triggerHoverIntent(targetElement);
      },
      onExit: () => {}
    })
};

homeDecorFurnitureFlyout.triggerHoverIntent = function _triggerHoverIntent(targetElement) {
  targetElement.dispatchEvent(new Event('hoverintent'));
};

// bind to all the necessary elements
homeDecorFurnitureFlyout.initialize = function initialize() {
  utils.addListenersToAll(['click', 'touchend', 'hoverintent'],
    '.Header3 .ShoppingLinks__link[data-id="homeDecorFurniture"]', homeDecorFurnitureFlyout.getFlyoutData);

  new SV.HoverIntent(document.querySelectorAll('.Header3 .ShoppingLinks__link[data-id="homeDecorFurniture"]'),
    {
      onEnter: (targetElement) => {
        homeDecorFurnitureFlyout.triggerHoverIntent(targetElement);
      },
      onExit: () => {}
    })

    // TODO: this hover intent event doesn't seem to actually do much for us
    // investigate our registerHoverIntent's and make sure they are somehow useful
  utils.delegateListeners(['click', 'touchend', 'hoverintent'],
    '.homeDecorFurnitureFlyout__subnav .homeDecorFurnitureFlyout__link', homeDecorFurnitureFlyout.interactWithAisle);
  utils.delegateListeners(['click', 'touchend'],
    '.homeDecorFurnitureFlyout__menu .homeDecorFurnitureFlyout__endpoint', homeDecorFurnitureFlyout.logInteractionForL3);
  
  homeDecorFurnitureFlyout.registerHoverIntent('.homeDecorFurnitureFlyout__link');
};

homeDecorFurnitureFlyout.init = function init() {
  homeDecorFurnitureFlyout.initialize();
  homeDecorFurnitureFlyout.getFlyoutData();

  headerData.init();
  headerAnalytics.init();

  return this;
};

homeDecorFurnitureFlyout.getBreadcrumbAisleElement = function getBreadcrumbAisleElement() {
  return homeDecorFurnitureFlyout.breadcrumbAisleElement;
};

homeDecorFurnitureFlyout.getHomeDecorFurnitureData = function getHomeDecorFurnitureData() {
  return homeDecorFurnitureData;
};

homeDecorFurnitureFlyout.highlightSubnavAisle = function highlightSubnavAisle(menu, item) {
  homeDecorFurnitureFlyout.highlightAisle(menu, item);
};

homeDecorFurnitureFlyout.getPrivateMethods = () => homeDecorFurnitureFlyout;

export default homeDecorFurnitureFlyout;